import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";

function CustomerModal(props) {
    const { array } = props
    const { title } = props
    const { onClick } = props
    //const { type } = props
    const [query, setQuery] = useState("")
    return (
        <Fragment>
            <Modal
                show={props.show}
                onHide={props.onHide}
                className="product-quickview-modal-wrapper"
            >
                <Modal.Header>{title}</Modal.Header>

                <div className="modal-body">
                    <div>
                        <input type="text" placeholder="Cerca qui" onChange={(event) => setQuery(event.target.value)} style={{marginBottom:"10px"}}/>
                        {array ? array.map((item, key) => {
                            return (
                                item.value ? item.value.toLowerCase().includes(query.toLowerCase()) && 
                                    <button style={{ display: "block", border: "none", backgroundColor: "white" }} key={key} onClick={() => onClick(item.id)}>
                                        {item.value}
                                    </button> : ""
                            )
                        }) : ""}
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}

CustomerModal.propTypes = {
    array: PropTypes.array
};

const mapStateToProps = state => {
    return {
        cartitems: state.cartData
    };
};

export default connect(mapStateToProps)(CustomerModal);
